import React from 'react';
import { IoClose, IoCheckmarkCircle, IoCalendar, IoCard, IoTime, IoTrash } from 'react-icons/io5';
import { Deadline, DeadlineType } from '../index';

interface EditDeadlineModalProps {
  deadline: Deadline;
  onClose: () => void;
  getTypeIcon: (type: DeadlineType) => JSX.Element;
  getTypeColor: (type: DeadlineType) => string;
}

const EditDeadlineModal: React.FC<EditDeadlineModalProps> = ({
  deadline,
  onClose,
  getTypeIcon,
  getTypeColor,
}) => {
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleAction = (action: string) => {
    console.log(`${action} for ${deadline.name}`);
    
    switch (action) {
      case 'view_tasks':
        alert(`View remaining tasks for ${deadline.name}`);
        break;
      case 'change_deadline':
        alert(`Change deadline for ${deadline.name}`);
        break;
      case 'view_scholarships':
        alert(`View scholarships for ${deadline.name}`);
        break;
      case 'remove':
        if (confirm(`Are you sure you want to remove ${deadline.name}?`)) {
          alert(`Removed ${deadline.name}`);
        }
        break;
      case 'edit':
        alert(`Edit ${deadline.name}`);
        break;
      default:
        break;
    }
    
    onClose();
  };

  const getProgressColor = (progress: number) => {
    if (progress >= 80) return 'green';
    if (progress >= 50) return 'blue';
    if (progress >= 25) return 'yellow';
    return 'red';
  };

  return (
    <div className="modal-overlay" onClick={handleBackdropClick}>
      <div className="modal-content edit-modal">
        <div className="modal-header">
          <h2 className="modal-title">Options for {deadline.name}</h2>
          <button className="modal-close-btn" onClick={onClose}>
            <IoClose />
          </button>
        </div>

        <div className="edit-modal-content">
          {/* Progress Preview */}
          <div className="progress-preview">
            <div className="progress-header">
              <span className="progress-label">Progress</span>
              <span className="progress-value">{deadline.progress}%</span>
            </div>
            <div className="progress-bar-container">
              <div 
                className={`progress-bar-fill progress-${getProgressColor(deadline.progress)}`}
                style={{ width: `${deadline.progress}%` }}
              />
            </div>
            {deadline.estimatedTimeHours > 0 && (
              <div className="time-estimate">
                <IoTime />
                <span>Est. time remaining: <strong>{deadline.estimatedTimeHours} hrs</strong></span>
              </div>
            )}
          </div>

          {/* Action Options */}
          <div className="edit-options">
            {(deadline.type === 'application' || deadline.type === 'scholarship') ? (
              <>
                <button 
                  className="edit-option-btn"
                  onClick={() => handleAction('view_tasks')}
                >
                  <IoCheckmarkCircle />
                  <span>View Remaining Tasks</span>
                </button>
                
                <button 
                  className="edit-option-btn"
                  onClick={() => handleAction('change_deadline')}
                >
                  <IoCalendar />
                  <span>Change deadline (RD/EA/ED)</span>
                </button>
                
                {deadline.type === 'application' && (
                  <button 
                    className="edit-option-btn"
                    onClick={() => handleAction('view_scholarships')}
                  >
                    <IoCard />
                    <span>View Scholarships</span>
                  </button>
                )}
                
                <button 
                  className="edit-option-btn danger"
                  onClick={() => handleAction('remove')}
                >
                  <IoTrash />
                  <span>
                    {deadline.type === 'application' 
                      ? "I'm no longer applying to this college"
                      : "Remove this deadline"
                    }
                  </span>
                </button>
              </>
            ) : (
              <button 
                className="edit-option-btn"
                onClick={() => handleAction('edit')}
              >
                <IoTime />
                <span>Edit Deadline</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditDeadlineModal;